export const LudicrousWide = 1440;
export const ExtraWide = 1170;
export const Wide = 768;
export const Narrow = 450;
